module.exports = __webpack_public_path__ + "static/media/chilli.ba0d1516.png";